import React from 'react';
import { styled } from 'linaria/react';
import { Partners } from '@shared/lib/partner';
import { withTheme } from '@shared/lib';
import { SbpIcon } from '@shared/assets/icons';
export const getDescriptionByPartner = (partner: Partners) => {
  switch (partner) {
    case Partners.DEFAULT:
      return null;
    default:
      return <Wrapper>
          <Description>Оплата по «Системе быстрых платежей»</Description>
          <SbpIcon />
        </Wrapper>;
  }
};
const Wrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1yfw5o3",
  propsAsIs: false
}));
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const Description = withTheme(/*#__PURE__*/styled('div')({
  name: "Description",
  class: "d1mtkqw1",
  propsAsIs: false,
  vars: {
    "d1mtkqw1-0": [_exp()],
    "d1mtkqw1-1": [_exp2(), "px"],
    "d1mtkqw1-2": [_exp3()],
    "d1mtkqw1-3": [_exp4()],
    "d1mtkqw1-4": [_exp5(), "px"]
  }
}));

require("./getDescriptionByPartner.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./getDescriptionByPartner.tsx");